import createHelixModuleApi from 'api/helix/utils/createHelixModuleApi';

const { api: resourceBookingApi } = createHelixModuleApi(
  api => `resource-booking/v2/building/${api.getState().config.buildingUuid}`,
);

export default resourceBookingApi;
